// Business detail page (v2 redesign) — sheets, save-to-collection,
// open/closed status, hours, reviews, share, map, OTP modal.
// Markup contract: bdp- prefixed classes rendered by app/views/businesses/show/.

(function () {
  var TOAST_MS = 2600;

  function root() {
    return document.getElementById('business-detail-v2');
  }

  function csrfToken() {
    var meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
  }

  function track(event, props) {
    if (typeof window.clicked === 'function') window.clicked(event, props || {});
  }

  // ── Toast ─────────────────────────────────────────────
  var toastTimer = null;
  function showToast(msg) {
    var existing = document.querySelector('.bdp-toast');
    if (existing) existing.remove();
    if (toastTimer) clearTimeout(toastTimer);

    var toast = document.createElement('div');
    toast.className = 'bdp-toast';
    toast.innerHTML =
      '<span class="bdp-toast-ic">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
      '</span><span class="bdp-toast-msg"></span>';
    toast.querySelector('.bdp-toast-msg').textContent = msg;
    document.body.appendChild(toast);
    toastTimer = setTimeout(function () { toast.remove(); }, TOAST_MS);
  }

  // ── Sheets ────────────────────────────────────────────
  function openSheet(id) {
    var scrim = document.getElementById(id);
    if (!scrim) return;
    scrim.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeSheet(scrim) {
    scrim.hidden = true;
    document.body.style.overflow = '';
  }

  function closeAllSheets() {
    document.querySelectorAll('.bdp-sheet-scrim').forEach(function (s) { closeSheet(s); });
  }

  // ── Save to collection ────────────────────────────────
  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken(),
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (resp) {
      return resp.json().then(function (data) { return { ok: resp.ok, status: resp.status, data: data }; });
    });
  }

  function updateSaveButtons(savedCount) {
    var saved = savedCount > 0;
    document.querySelectorAll('.bdp-save-btn').forEach(function (btn) {
      var circular = btn.classList.contains('bdp-circ-btn');
      btn.classList.toggle(circular ? 'bdp-circ-btn--saved' : 'bdp-btn--saved', saved);
      var label = btn.querySelector('.bdp-save-label');
      if (label) label.textContent = saved ? (savedCount > 1 ? 'Saved · ' + savedCount : 'Saved') : 'Save';
    });
  }

  function placesLabel(count) {
    return count + (count === 1 ? ' place' : ' places');
  }

  function updateCollectionRow(row, data) {
    row.classList.toggle('bdp-coll-row--in', data.saved);
    var check = row.querySelector('.bdp-coll-check');
    if (check) check.classList.toggle('bdp-coll-check--on', data.saved);
    var count = row.querySelector('.bdp-coll-count');
    if (count) count.textContent = placesLabel(data.collection.businesses_count);
  }

  function buildCollectionRow(sheet, data) {
    var row;
    var template = sheet.querySelector('.bdp-coll-row');
    if (template) {
      row = template.cloneNode(true);
      updateCollectionRow(row, data);
      var name = row.querySelector('.bdp-coll-name');
      if (name) name.textContent = data.collection.label;
    } else {
      row = document.createElement('button');
      row.type = 'button';
      row.className = 'bdp-coll-row bdp-coll-row--in';
      row.innerHTML =
        '<span class="bdp-coll-emoji">📍</span>' +
        '<span class="bdp-coll-body"><span class="bdp-coll-name"></span>' +
        '<span class="bdp-coll-count"></span></span>' +
        '<span class="bdp-coll-check bdp-coll-check--on">' +
        '<svg class="bdp-ic-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
        '</span>';
      row.querySelector('.bdp-coll-name').textContent = data.collection.label;
      row.querySelector('.bdp-coll-count').textContent = placesLabel(data.collection.businesses_count);
    }
    row.dataset.uid = data.collection.uid;
    return row;
  }

  function toggleCollection(row) {
    var sheet = document.getElementById('bdp-collection-sheet');
    if (!sheet || row.dataset.bdpBusy) return;
    row.dataset.bdpBusy = '1';

    postJSON(sheet.dataset.toggleUrl, { collection_uid: row.dataset.uid })
      .then(function (result) {
        if (!result.ok) {
          showToast(result.data.error || 'Something went wrong');
          return;
        }
        updateCollectionRow(row, result.data);
        updateSaveButtons(result.data.saved_count);
        var label = result.data.collection.label;
        showToast(result.data.saved ? 'Saved to ' + label : 'Removed from ' + label);
        if (result.data.saved) {
          var el = root();
          track('Saved Business to Collection', {
            business_name: el ? el.dataset.businessName : '',
            collection: label
          });
        }
      })
      .catch(function () { showToast('Something went wrong'); })
      .finally(function () { delete row.dataset.bdpBusy; });
  }

  function showCreateError(msg) {
    var err = document.getElementById('bdp-coll-error');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }

  function createCollection() {
    var sheet = document.getElementById('bdp-collection-sheet');
    var input = document.getElementById('bdp-coll-input');
    if (!sheet || !input) return;
    var label = input.value.trim();
    if (!label) return;

    var submit = document.getElementById('bdp-coll-submit');
    if (submit) submit.disabled = true;

    postJSON(sheet.dataset.createUrl, { label: label })
      .then(function (result) {
        if (!result.ok) {
          showCreateError(result.data.error || 'Could not create collection');
          return;
        }
        var list = sheet.querySelector('.bdp-sheet-list');
        var row = buildCollectionRow(sheet, result.data);
        if (list) list.appendChild(row);
        var hint = sheet.querySelector('.bdp-coll-hint');
        if (hint) hint.remove();
        updateSaveButtons(result.data.saved_count);
        showToast('Created “' + result.data.collection.label + '”');
        input.value = '';
        var err = document.getElementById('bdp-coll-error');
        if (err) err.hidden = true;
        var create = document.getElementById('bdp-coll-create');
        var newBtn = document.getElementById('bdp-coll-new');
        if (create) create.hidden = true;
        if (newBtn) newBtn.hidden = false;
      })
      .catch(function () { showCreateError('Could not create collection'); })
      .finally(function () { if (submit) submit.disabled = false; });
  }

  // ── Write a review ────────────────────────────────────
  var MAX_REVIEW_PHOTOS = 6;
  // Accumulates chosen photos across multiple picker opens; the native input
  // can't be appended to, so we keep our own list and rebuild previews from it.
  var reviewPhotos = [];

  function reviewSheet() { return document.getElementById('bdp-review-sheet'); }

  function showReviewError(msg) {
    var err = document.getElementById('bdp-review-error');
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }

  function clearReviewError() {
    var err = document.getElementById('bdp-review-error');
    if (err) err.hidden = true;
  }

  function setReviewRating(value) {
    var hidden = document.getElementById('bdp-review-rating');
    if (hidden) hidden.value = String(value);
    document.querySelectorAll('.bdp-star-btn').forEach(function (btn) {
      btn.classList.toggle('bdp-star-btn--on', Number(btn.dataset.value) <= value);
    });
    var caption = document.getElementById('bdp-star-caption');
    if (caption) {
      caption.textContent = value > 0 ? value + ' out of 5' : 'Tap a star to rate';
      caption.classList.toggle('bdp-star-caption--set', value > 0);
    }
    clearReviewError();
  }

  function renderReviewPreviews() {
    var strip = document.getElementById('bdp-review-previews');
    if (!strip) return;
    strip.innerHTML = '';
    reviewPhotos.forEach(function (file, index) {
      var cell = document.createElement('div');
      cell.className = 'bdp-review-thumb';
      var img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = '';
      img.onload = function () { URL.revokeObjectURL(img.src); };
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bdp-review-thumb-remove';
      remove.setAttribute('aria-label', 'Remove photo');
      remove.dataset.reviewRemove = String(index);
      remove.innerHTML =
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
      cell.appendChild(img);
      cell.appendChild(remove);
      strip.appendChild(cell);
    });
  }

  function addReviewPhotos(fileList) {
    Array.prototype.forEach.call(fileList, function (file) {
      if (reviewPhotos.length >= MAX_REVIEW_PHOTOS) return;
      if (!/^image\//.test(file.type)) return;
      reviewPhotos.push(file);
    });
    if (fileList.length && reviewPhotos.length >= MAX_REVIEW_PHOTOS) {
      showReviewError('You can add up to ' + MAX_REVIEW_PHOTOS + ' photos.');
    }
    renderReviewPreviews();
  }

  function removeReviewPhoto(index) {
    reviewPhotos.splice(index, 1);
    renderReviewPreviews();
    clearReviewError();
  }

  function submitReview() {
    var sheet = reviewSheet();
    if (!sheet) return;
    var rating = Number((document.getElementById('bdp-review-rating') || {}).value || 0);
    if (!(rating >= 1 && rating <= 5)) {
      showReviewError('Please choose a rating.');
      return;
    }

    var submit = document.getElementById('bdp-review-submit');
    if (submit) submit.disabled = true;

    var form = new FormData();
    form.append('rating', String(rating));
    var text = document.getElementById('bdp-review-text');
    var label = document.getElementById('bdp-review-label-input');
    if (text && text.value.trim()) form.append('review', text.value.trim());
    if (label && label.value.trim()) form.append('label', label.value.trim());
    reviewPhotos.forEach(function (file) { form.append('photos[]', file); });

    fetch(sheet.dataset.createUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken(),
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: form
    })
      .then(function (resp) {
        return resp.json().then(function (data) { return { ok: resp.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          showReviewError((result.data && result.data.error) || 'Could not save your review.');
          if (submit) submit.disabled = false;
          return;
        }
        track('Wrote Review', {
          business: sheet.dataset.business || '',
          business_type: sheet.dataset.businessType || '',
          rating: rating
        });
        var scrim = reviewSheet();
        if (scrim) closeSheet(scrim);
        showToast('Review posted');
        setTimeout(function () { window.location.reload(); }, 900);
      })
      .catch(function () {
        showReviewError('Could not save your review.');
        if (submit) submit.disabled = false;
      });
  }

  // ── Review photo lightbox (gallery) ───────────────────
  var lightboxUrls = [];
  var lightboxIndex = 0;

  // Open from a clicked photo button; the gallery is every photo in the SAME
  // review's `.bdp-rev-photos` strip, so prev/next steps through that review.
  function openLightbox(trigger) {
    var box = document.getElementById('bdp-lightbox');
    if (!box || !trigger) return;
    var group = trigger.closest('.bdp-rev-photos');
    var nodes = group ? group.querySelectorAll('[data-bdp-lightbox]') : [trigger];
    lightboxUrls = Array.prototype.map.call(nodes, function (n) { return n.dataset.bdpLightbox; });
    lightboxIndex = Math.max(0, Array.prototype.indexOf.call(nodes, trigger));
    box.hidden = false;
    document.body.style.overflow = 'hidden';
    showLightboxImage(lightboxIndex);
  }

  function showLightboxImage(i) {
    var box = document.getElementById('bdp-lightbox');
    if (!box || !lightboxUrls.length) return;
    var n = lightboxUrls.length;
    lightboxIndex = ((i % n) + n) % n; // wrap around
    var img = box.querySelector('.bdp-lightbox-img');
    if (img) img.src = lightboxUrls[lightboxIndex];

    var multi = n > 1;
    box.querySelectorAll('.bdp-lightbox-nav').forEach(function (b) { b.hidden = !multi; });
    var count = box.querySelector('.bdp-lightbox-count');
    if (count) {
      count.hidden = !multi;
      count.textContent = (lightboxIndex + 1) + ' / ' + n;
    }
  }

  function stepLightbox(delta) {
    if (lightboxUrls.length > 1) showLightboxImage(lightboxIndex + delta);
  }

  function lightboxOpen() {
    var box = document.getElementById('bdp-lightbox');
    return box && !box.hidden;
  }

  function closeLightbox() {
    var box = document.getElementById('bdp-lightbox');
    if (!box) return;
    box.hidden = true;
    var img = box.querySelector('.bdp-lightbox-img');
    if (img) img.src = '';
    lightboxUrls = [];
    document.body.style.overflow = '';
  }

  // ── Open/closed status ────────────────────────────────
  function formatSeconds(totalSeconds) {
    var secs = ((totalSeconds % 86400) + 86400) % 86400;
    var hours = Math.floor(secs / 3600);
    var minutes = Math.floor((secs % 3600) / 60);
    var suffix = hours >= 12 ? 'PM' : 'AM';
    var h12 = hours % 12 === 0 ? 12 : hours % 12;
    return h12 + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + suffix;
  }

  function computeStatus(hours) {
    if (!hours || hours.accepted_hours === false || hours.accepted_hours === undefined) return null;

    var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var today = days[new Date().getDay()];
    var now = new Date();
    var nowSecs = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    var shifts = [];
    Object.keys(hours).forEach(function (key) {
      if (key === 'accepted_hours') return;
      if (key.split('_')[0] !== today) return;
      var range = hours[key] && hours[key].seconds_hours_range;
      if (!range || hours[key]._12_hour_format === 'Closed') return;
      var open = range.open;
      var closes = range.closes;
      if (open > closes) closes += 86400; // overnight shift (matches legacy isOpen())
      shifts.push({ open: open, closes: closes });
    });

    for (var i = 0; i < shifts.length; i++) {
      if (nowSecs >= shifts[i].open && nowSecs <= shifts[i].closes) {
        return { open: true, text: 'Open · closes ' + formatSeconds(shifts[i].closes) };
      }
    }

    var upcoming = shifts.filter(function (s) { return s.open > nowSecs; })
      .sort(function (a, b) { return a.open - b.open; })[0];
    if (upcoming) return { open: false, text: 'Closed · opens ' + formatSeconds(upcoming.open) };
    return { open: false, text: 'Closed' };
  }

  function fillStatusChips() {
    var dataEl = document.getElementById('bdp-data');
    if (!dataEl) return;
    var payload;
    try { payload = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (payload.mobile) return;

    var status = computeStatus(payload.hours);
    if (!status) return;

    document.querySelectorAll('.bdp-status').forEach(function (chip) {
      chip.classList.remove('bdp-status--open', 'bdp-status--closed');
      chip.classList.add(status.open ? 'bdp-status--open' : 'bdp-status--closed');
      chip.innerHTML = '<span class="bdp-status-dot"></span>';
      chip.appendChild(document.createTextNode(status.text));
      chip.hidden = false;
    });
  }

  // ── Map (Apple MapKit; layout initializes mapkit on /businesses paths) ──
  function initMap(attempt) {
    var mapEl = document.getElementById('map');
    if (!mapEl || !mapEl.classList.contains('bdp-map-canvas')) return;
    if (mapEl.dataset.bdpMapInit) return;
    if (typeof window.mapkit === 'undefined') {
      // mapkit.js loads async from the layout; retry briefly
      attempt = attempt || 0;
      if (attempt < 20) setTimeout(function () { initMap(attempt + 1); }, 250);
      return;
    }
    mapEl.dataset.bdpMapInit = '1';

    var latMeta = document.querySelector('meta[property="place:location:latitude"]');
    var lngMeta = document.querySelector('meta[property="place:location:longitude"]');
    var lat = latMeta && parseFloat(latMeta.content);
    var lng = lngMeta && parseFloat(lngMeta.content);
    if (!lat || !lng) { lat = 41.85; lng = -87.65; }

    var el = root();
    var coordinate = new mapkit.Coordinate(lat, lng);
    var map = new mapkit.Map('map', {
      isScrollEnabled: true,
      isZoomEnabled: true,
      showsZoomControl: true,
      showsMapTypeControl: false
    });
    map.center = coordinate;
    map.cameraZoomRange = new mapkit.CameraZoomRange(10, 1000);
    map.region = new mapkit.CoordinateRegion(coordinate, new mapkit.CoordinateSpan(0.05, 0.05));
    map.setCenterAnimated(coordinate, true);
    map.addAnnotation(new mapkit.MarkerAnnotation(coordinate, {
      selected: true,
      color: '#AC0168',
      title: el ? el.dataset.businessName : ''
    }));
  }

  // ── Embed iframe helpers (embed modal markup calls these) ──
  window.generateIframe = function () {
    var iframe = '<iframe height="215px" width="100%" title="Business Card Embed" style="border:none;" src="' + window.location.href + '/iframe"></iframe>';
    if (navigator.clipboard) navigator.clipboard.writeText(iframe);
    var area = document.querySelector('textarea#iframe');
    if (area) {
      area.value = iframe;
      area.classList.remove('hide');
    }
    document.querySelectorAll('a.hide').forEach(function (a) { a.classList.remove('hide'); });
    var preview = document.getElementById('preview');
    if (preview) preview.innerHTML = iframe;
  };

  window.copyIframe = function () {
    var area = document.getElementById('iframe');
    if (!area) return;
    area.select();
    if (navigator.clipboard) navigator.clipboard.writeText(area.value);
  };

  // ── OTP modal (Text Me This Business) ─────────────────
  function initOtpModal() {
    var input = document.querySelector('#phone_number');
    var mainBtn = document.querySelector('#send-otp');
    var validMsg = document.querySelector('#valid-msg');
    var addressDropdown = document.querySelector('#country_code');
    if (!input || !mainBtn || !validMsg || input.dataset.bdpOtpInit) return;
    if (typeof window.intlTelInput === 'undefined') return;
    input.dataset.bdpOtpInit = '1';

    var iti = window.intlTelInput(input, {
      preferredCountries: ['us', 'in', 'de', 'co'],
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.min.js'
    });

    var reset = function () {
      input.classList.remove('error');
      validMsg.innerHTML = ' ';
      validMsg.classList.add('hide');
    };

    input.addEventListener('countrychange', function () {
      addressDropdown.value = '+' + iti.getSelectedCountryData().dialCode;
    });

    input.addEventListener('keyup', function () {
      reset();
      if (!input.value.trim()) return;
      var sendLink = document.getElementById('send-pin-link');
      if (iti.isValidNumber()) {
        validMsg.classList.remove('hide');
        validMsg.innerHTML = '✓ Valid Mobile Number';
        validMsg.style.color = 'green';
        addressDropdown.value = '+' + iti.getSelectedCountryData().dialCode;
        if (sendLink) sendLink.removeAttribute('disabled');
      } else {
        input.classList.add('error');
        validMsg.innerHTML = 'Please Enter Valid Mobile Number!!!';
        validMsg.classList.remove('hide');
        validMsg.style.color = 'red';
        if (sendLink) sendLink.setAttribute('disabled', 'disabled');
      }
    });

    mainBtn.addEventListener('click', reset);

    // Phone input mask: (XXX) XXX-XXXX
    input.addEventListener('keyup', maskPhone);
    input.addEventListener('paste', maskPhone);
    function maskPhone(event) {
      if (event.which === 8) return;
      var raw = input.value.replace(/[^0-9\(\)\s\-]/g, '');
      var inputlen = raw.length;
      var numbers = input.value.replace(/\D/g, '');
      var numberslen = numbers.length;
      var newval = '';
      for (var i = 0; i < numberslen; i++) {
        if (i === 0) newval = '(' + numbers[i];
        else if (i === 2) newval += numbers[i] + ') ';
        else if (i === 6) newval += '-' + numbers[i];
        else newval += numbers[i];
      }
      if (inputlen >= 1 && numberslen === 0 && raw[0] === '(') newval = '(';
      else if (inputlen >= 6 && numberslen === 3 && raw[4] === ')' && raw[5] === ' ') newval += ') ';
      else if (inputlen >= 5 && numberslen === 3 && raw[4] === ')') newval += ' ';
      else if (inputlen >= 6 && numberslen === 3 && raw[5] === ' ') newval += ' ';
      else if (inputlen >= 10 && numberslen === 6 && raw[9] === '-') newval += '-';
      input.value = newval.substring(0, 14);
    }

    var pin = document.getElementById('pin');
    if (pin) {
      pin.addEventListener('keyup', function () {
        var pinCode = pin.value;
        fetch('/user_verifications/pin_validate?pin=' + encodeURIComponent(pinCode), {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            var verified = document.getElementById('pin-verified');
            var message = document.getElementById('otp-message');
            if (!verified || !message) return;
            if (response.pin_data.is_valid === true && pinCode.length === 6) {
              verified.removeAttribute('disabled');
              message.innerHTML = response.pin_data.message;
              message.style.color = 'green';
            } else if (response.pin_data.is_valid === false) {
              verified.setAttribute('disabled', 'disabled');
              message.innerHTML = response.pin_data.message;
              message.style.color = 'red';
            } else {
              verified.removeAttribute('disabled');
              message.innerHTML = '';
            }
          })
          .catch(function () {});
      });
    }
  }

  // ── Delegated events (bound once) ─────────────────────
  function bindDelegatedEvents() {
    if (window.__bdpBound) return;
    window.__bdpBound = true;

    document.addEventListener('click', function (e) {
      if (!root()) return;

      var opener = e.target.closest('[data-bdp-open]');
      if (opener) {
        e.preventDefault();
        openSheet('bdp-' + opener.dataset.bdpOpen);
        return;
      }

      var closer = e.target.closest('[data-bdp-close]');
      if (closer) {
        e.preventDefault();
        var scrim = closer.closest('.bdp-sheet-scrim');
        if (scrim) closeSheet(scrim);
        return;
      }

      // Click on the scrim backdrop itself closes the sheet
      if (e.target.classList && e.target.classList.contains('bdp-sheet-scrim')) {
        closeSheet(e.target);
        return;
      }

      var collRow = e.target.closest('.bdp-coll-row');
      if (collRow) {
        e.preventDefault();
        toggleCollection(collRow);
        return;
      }

      var collNew = e.target.closest('#bdp-coll-new');
      if (collNew) {
        e.preventDefault();
        collNew.hidden = true;
        var create = document.getElementById('bdp-coll-create');
        if (create) {
          create.hidden = false;
          var input = document.getElementById('bdp-coll-input');
          if (input) input.focus();
        }
        return;
      }

      if (e.target.closest('#bdp-coll-submit')) {
        e.preventDefault();
        createCollection();
        return;
      }

      var starBtn = e.target.closest('.bdp-star-btn');
      if (starBtn) {
        e.preventDefault();
        setReviewRating(Number(starBtn.dataset.value));
        return;
      }

      var thumbRemove = e.target.closest('[data-review-remove]');
      if (thumbRemove) {
        e.preventDefault();
        removeReviewPhoto(Number(thumbRemove.dataset.reviewRemove));
        return;
      }

      if (e.target.closest('#bdp-review-submit')) {
        e.preventDefault();
        submitReview();
        return;
      }

      var lightboxTrigger = e.target.closest('[data-bdp-lightbox]');
      if (lightboxTrigger) {
        e.preventDefault();
        openLightbox(lightboxTrigger);
        return;
      }

      if (e.target.closest('[data-bdp-lightbox-prev]')) {
        e.preventDefault();
        stepLightbox(-1);
        return;
      }
      if (e.target.closest('[data-bdp-lightbox-next]')) {
        e.preventDefault();
        stepLightbox(1);
        return;
      }

      // Close on the close button or a click on the overlay backdrop itself.
      if (e.target.closest('[data-bdp-lightbox-close]') ||
          (e.target.id === 'bdp-lightbox')) {
        e.preventDefault();
        closeLightbox();
        return;
      }

      var back = e.target.closest('.bdp-back');
      if (back) {
        e.preventDefault();
        if (window.history.length > 1) window.history.back();
        else window.location.href = '/discover';
        return;
      }

      var hoursToggle = e.target.closest('.bdp-hours-toggle');
      if (hoursToggle) {
        e.preventDefault();
        var list = document.querySelector('.bdp-hours-list');
        var open = list && list.classList.toggle('bdp-hours-list--open');
        hoursToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var chev = hoursToggle.querySelector('.bdp-chev');
        if (chev) chev.classList.toggle('bdp-chev--open', !!open);
        return;
      }

      var loadMore = e.target.closest('#bdp-load-more');
      if (loadMore) {
        e.preventDefault();
        document.querySelectorAll('.bdp-rev.bdp-hidden').forEach(function (rev) {
          rev.classList.remove('bdp-hidden');
        });
        loadMore.hidden = true;
        return;
      }

      var shareBtn = e.target.closest('#bdp-share-btn');
      if (shareBtn) {
        e.preventDefault();
        var pop = document.getElementById('bdp-share-pop');
        if (pop) pop.hidden = !pop.hidden;
        return;
      }

      var copyLink = e.target.closest('[data-bdp-copy-url]');
      if (copyLink) {
        e.preventDefault();
        var url = copyLink.dataset.bdpCopyUrl;
        if (navigator.clipboard && url) navigator.clipboard.writeText(url);
        showToast('Link copied');
        var sharePop = document.getElementById('bdp-share-pop');
        if (sharePop) sharePop.hidden = true;
        return;
      }

      // Any other click closes an open share popover
      var openPop = document.getElementById('bdp-share-pop');
      if (openPop && !openPop.hidden && !e.target.closest('#bdp-share-pop')) {
        openPop.hidden = true;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!root()) return;
      if (e.key === 'Escape') { closeAllSheets(); closeLightbox(); }
      if (lightboxOpen()) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); stepLightbox(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); stepLightbox(1); }
      }
      if (e.key === 'Enter' && e.target && e.target.id === 'bdp-coll-input') {
        e.preventDefault();
        createCollection();
      }
    });

    document.addEventListener('change', function (e) {
      if (!root()) return;
      if (e.target && e.target.id === 'bdp-review-photos') {
        addReviewPhotos(e.target.files);
        e.target.value = ''; // allow re-selecting the same file after removal
      }
    });
  }

  // Auto-open the review sheet when returning from sign-in (?write_review=1).
  function maybeOpenReviewFromParam() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('write_review') !== '1') return;
    if (!reviewSheet()) return;
    openSheet('bdp-review-sheet');
    params.delete('write_review');
    var qs = params.toString();
    var clean = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({}, document.title, clean);
  }

  // ── Per-visit init ────────────────────────────────────
  function init() {
    if (!root()) return;
    bindDelegatedEvents();
    fillStatusChips();
    initMap();
    initOtpModal();
    maybeOpenReviewFromParam();
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('turbolinks:load', init);
  init();
})();
